
    <!--
 * 横版-签到领奖
 * @LastEditTime: Mon Jan 06 2025 17:26:50 GMT+0800 (China Standard Time)
 -->
 <template>
  <div id="u_c_PU3219"  :class="[`normal`,`u_c_PU3219`]" ><div id="u_c_4XT324"  v-html="compData.title" :class="[`${ compData.title ? 'text' : '' }`,`normal`,`u_c_4XT324`]" ></div><div id="u_c_FWNF17"  v-html="compData.subTitle" :class="[`normal`,`u_c_FWNF17`]" ></div><div id="u_c_PHXH28"  :class="[`normal`,`u_c_PHXH28`]" ><span id="u_c_EHIZ29"  :class="[`normal txt`,`u_c_EHIZ29`]" >{{`${ langData.mySignTime }:`}}</span><span id="u_c_U3DG31"  :class="[`normal txt`,`u_c_U3DG31`]" >{{`${ pageData.signTime }`}}</span><span id="u_c_V2CG35"  :class="[`normal txt`,`u_c_V2CG35`]" >{{`${ langData.day }`}}</span></div><div id="u_c_IA8J17"  :class="[`normal`,`u_c_IA8J17`]" ><div id="u_c_MNBL18"  v-for="(signItem, signIndex) in compData.signInfo" :key="signIndex" :data-index="signItem.day" :class="[`normal sign-item btn-light`,`u_c_MNBL18`]" @click="u_c_MNBL18_event_W81W61($event,signIndex)"><div id="u_c_156W17"  :class="[`normal`,`u_c_156W17`]" >{{`${ signItem.day }${ langData.day }`}}</div><div id="u_c_W7BU19"  :style="`background-image:url(${ signItem.pic })`" :class="[`u_c_W7BU19_${signIndex}`,`normal sign-img`,`u_c_W7BU19`]" ></div><div id="u_c_1TRJ20"  v-show="signItem.state == 2 || signItem.state == void 0 && signIndex == 0" :class="[`normal`,`u_c_1TRJ20`]" ></div></div></div><a id="u_c_S2XY22" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal  btn-light `,`u_c_S2XY22`]" @click="u_c_S2XY22_event_8J5W26($event)"><div id="u_c_S2S020"  :class="[`normal page-common-btn`,`u_c_S2S020`]" >{{`${ langData.getBtn }`}}</div></a></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"signInfo":[{"name":"签到第1个奖励\n签到第1-1个奖励\n签到第1-2个奖励\n签到第1-3个奖励","day":"1","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189607104.png"},{"name":"签到第2个奖励","day":"2","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/1675418960122.png"},{"name":"签到第3个奖励","day":"3","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189607890.png"},{"name":"签到第4个奖励","day":"4","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189609844.png"},{"name":"签到第5个奖励","day":"5","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189609538.png"},{"name":"签到第6个奖励","day":"6","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/1675418960221.png"},{"name":"签到第7个奖励","day":"7","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189606833.png"}],"subTitle":`累计签到达到以下次数，可领取活动奖励`,"title":`九考特训
签到送好礼`},"zh-CN":{"signInfo":[{"name":"加速训练5分钟*10\n研发加速5分钟*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"钻石*50\n加速训练5分钟*10\n研发加速5分钟*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"钻石*100\n加速训练5分钟*10\n研发加速5分钟*10\n加速建造5分钟*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"钻石*150\n5星英雄万能碎片*1\n加速训练5分钟*10\n研发加速5分钟*10\n加速建造5分钟*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`活动期间，每日登入活动页面，即可完成签到，累计签到天数达到1、3、5、7天后，即可领取签到奖励；`,"title":`每日签到送不停`},"zh-TW":{"signInfo":[{"name":"加速訓練5分鐘*10\n研發加速5分鐘*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"鑽石*50\n加速訓練5分鐘*10\n研發加速5分鐘*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"鑽石*100\n加速訓練5分鐘*10\n研發加速5分鐘*10\n加速建造5分鐘*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"鑽石*150\n5星英雄萬能碎片*1\n加速訓練5分鐘*10\n研發加速5分鐘*10\n加速建造5分鐘*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`活動期間，每日登入活動頁面，即可完成簽到，累計簽到天數達到1、3、5、7天後，即可領取簽到獎勵；`,"title":`每日簽到送不停`},"en-US":{"signInfo":[{"name":"5-min Training Speedup*10\n5-min Research Speedup*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diamond*50\n5-min Training Speedup*10\n5-min Research Speedup*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diamond*100\n5-min Training Speedup*10\n5-min Research Speedup*10\n5-min Build Speedup*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diamond*150\n5★ Hero Perfect Frag*1\n5-min Training Speedup*10\n5-min Research Speedup*10\n5-min Build Speedup*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`Log in to the event page every day to sign in. Sign in for 1/3/5/7 day(s) to claim sign-in rewards.`,"title":`Daily Sign-in Reward`},"ja-JP":{"signInfo":[{"name":"訓練ブースト（5分間）*10\n研究ブースト（5分間）*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"ダイヤ*50\n訓練ブースト（5分間）*10\n研究ブースト（5分間）*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"ダイヤ*100\n訓練ブースト（5分間）*10\n研究ブースト（5分間）*10\n建造ブースト（5分間）*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"ダイヤ*150\n★5英雄の万能欠片*1\n訓練ブースト（5分間）*10\n研究ブースト（5分間）*10\n建造ブースト（5分間）*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`イベント期間中、毎日イベント画面からログインするとサインインが完了します。合計サインイン日数が1、3、5、7日に到達すると、対応するボーナスを受け取れます。`,"title":`毎日ログイン　ボーナス続々`},"ko-KR":{"signInfo":[{"name":"훈련 5분 가속*10\n개발 5분 가속*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"다이아*50\n훈련 5분 가속*10\n개발 5분 가속*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"다이아*100\n훈련 5분 가속*10\n개발 5분 가속*10\n건설 5분 가속*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"다이아*150\n5성 영웅 만능 조각*1\n훈련 5분 가속*10\n개발 5분 가속*10\n건설 5분 가속*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`이벤트 기간 동안 이벤트 페이지에 매일 접속하여 출석을 완료하면, 누적 출석 일수 1, 3, 5, 7일마다 출석 보상을 획득합니다.`,"title":`매일 출석하면 선물이 팡팡`},"th-TH":{"signInfo":[{"name":"เร่งสปีดฝึก5นาที*10\nเร่งสปีดการวิจัย5นาที*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"เพชร*50\nเร่งสปีดฝึก5นาที*10\nเร่งสปีดการวิจัย5นาที*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"เพชร*100\nเร่งสปีดฝึก5นาที*10\nเร่งสปีดการวิจัย5นาที*10\nเร่งสปีดสร้าง5นาที*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"เพชร*150\nชิปวิเศษฮีโร่ 5★*1\nเร่งสปีดฝึก5นาที*10\nเร่งสปีดการวิจัย5นาที*10\nเร่งสปีดสร้าง5นาที*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`ทุกวันที่เปิดหน้ากิจกรรมในช่วงกิจกรรม ก็จะถือว่าเช็คอินเสร็จสิ้น เมื่อเช็คอินสะสมครบ 1, 3, 5 และ 7 วัน จะรับรางวัลเช็คอินได้`,"title":`เช็คอินแล้ว รับรางวัลทันที`},"vi-VN":{"signInfo":[{"name":"Tăng tốc huấn luyện 5 phút*10\nTăng tốc nghiên cứu 5 phút*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Kim Cương*50\nTăng tốc huấn luyện 5 phút*10\nTăng tốc nghiên cứu 5 phút*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Kim Cương*100\nTăng tốc huấn luyện 5 phút*10\nTăng tốc nghiên cứu 5 phút*10\nTăng tốc xây 5 phút*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Kim Cương*150\nMảnh Anh hùng 5 Sao Vạn Năng*1\nTăng tốc huấn luyện 5 phút*10\nTăng tốc nghiên cứu 5 phút*10\nTăng tốc xây 5 phút*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`Trong thời gian hoạt động, đăng nhập giao diện hoạt động mỗi ngày là hoàn thành điểm danh, sau khi điểm danh đến 1, 3, 5, 7 ngày là được nhận thưởng điểm danh;`,"title":`Điểm Danh Hàng Ngày Nhận Quà Liền Tay`},"de-DE":{"signInfo":[{"name":"5 Min Training Beschleunigen*10\n5 Min Forschung Beschleunigen*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diamant*50\n5 Min Training Beschleunigen*10\n5 Min Forschung Beschleunigen*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diamant*100\n5 Min Training Beschleunigen*10\n5 Min Forschung Beschleunigen*10\n5 Min Bau Beschleunigen*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diamant*150\n5★ Held-Perfektes Fragment*1\n5 Min Training Beschleunigen*10\n5 Min Forschung Beschleunigen*10\n5 Min Bau Beschleunigen*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`Logge dich jeden Tag auf der Eventseite an, um dich anzumelden. Melde dich für 1/3/5/7 Tag(e) an, um Anmeldebelohnungen zu erhalten.`,"title":`Tägliche Anmeldebelohnung`},"fr-FR":{"signInfo":[{"name":"Accélération entraînement 5-min*10\nAccélération recherche 5-min*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diamant*50\nAccélération entraînement 5-min*10\nAccélération recherche 5-min*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diamant*100\nAccélération entraînement 5-min*10\nAccélération recherche 5-min*10\nAccélération bâtiment 5-min*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diamant*150\nFragment parfait de héros 5★*1\nAccélération entraînement 5-min*10\nAccélération recherche 5-min*10\nAccélération bâtiment 5-min*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`Connectez-vous à la page de l'événement tous les jours pour vous connecter. Connectez-vous pendant 1/3/5/7 jour(s) pour réclamer les récompenses de connexion.`,"title":`Récompense de Connexion Quotidienne`},"es-ES":{"signInfo":[{"name":"5 min de Aceleración de Entrenamiento*10\n5 min de Aceleración de investigación*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diamante*50\n5 min de Aceleración de Entrenamiento*10\n5 min de Aceleración de investigación*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diamante*100\n5 min de Aceleración de Entrenamiento*10\n5 min de Aceleración de investigación*10\n5 min de Aceleración de Construcción*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diamante*150\nFrag. Perfecto de Héroe 5★*1\n5 min de Aceleración de Entrenamiento*10\n5 min de Aceleración de investigación*10\n5 min de Aceleración de Construcción*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`Ingresa a la página del evento todos los días para registrarte. Regístrate por 1/3/5/7 día(s) para reclamar las recompensas de inicio de sesión.`,"title":`Recompensa de inscripción diaria`},"pt-PT":{"signInfo":[{"name":"5 min de Aceleração de Treinamento*10\n5 min de aceleração da Pesquisa*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diamante*50\n5 min de Aceleração de Treinamento*10\n5 min de aceleração da Pesquisa*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diamante*100\n5 min de Aceleração de Treinamento*10\n5 min de aceleração da Pesquisa*10\n5 minutos de Aceleração de Construção*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diamante*150\nFragmento de Herói Perfeito 5★*1\n5 min de Aceleração de Treinamento*10\n5 min de aceleração da Pesquisa*10\n5 minutos de Aceleração de Construção*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`Faça login na página do evento todos os dias para fazer entrar. Faça login por 1/3/5/7 dia(s) para reivindicar recompensas de login.`,"title":`Recompensa de Login Diário`},"it-IT":{"signInfo":[{"name":"Velocizz. Addestramento 5-min*10\nVelocizz. Ricerca 5-min*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diamante*50\nVelocizz. Addestramento 5-min*10\nVelocizz. Ricerca 5-min*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diamante*100\nVelocizz. Addestramento 5-min*10\nVelocizz. Ricerca 5-min*10\nVelocizz. Costruzione 5-min*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diamante*150\nFramm. Eroe Perfetto 5★*1\nVelocizz. Addestramento 5-min*10\nVelocizz. Ricerca 5-min*10\nVelocizz. Costruzione 5-min*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`Accedi alla pagina dell'evento ogni giorno per accedere. Accedi per 1/3/5/7 giorno/i per richiedere i premi di accesso.`,"title":`Ricompensa Accesso Giornaliero`},"tr-TR":{"signInfo":[{"name":"5-dk Eğitim Hızlandırma*10\n5-dk Araştırma Hızlandırma*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Elmas*505-dk Eğitim Hızlandırma*105-dk Araştırma Hızlandırma*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Elmas*100\n5-dk Eğitim Hızlandırma*10\n5-dk Araştırma Hızlandırma*10\n5-dk İnşa Hızlandırma*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Elmas*150\n5★ Kahraman Mükemmel Parça*1\n5-dk Eğitim Hızlandırma*10\n5-dk Araştırma Hızlandırma*10\n5-dk İnşa Hızlandırma*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`Oturum açmak için her gün etkinlik sayfasına giriş yap. Oturum ödüllerini talep etmek için 1/3/5/7 gün giriş yap.`,"title":`Günlük Giriş Ödülü`},"pl-PL":{"signInfo":[{"name":"5-min. Przyśpieszenie Szkolenia*10\n5-min. Przyśpieszenie Badań*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diament*505-min. Przyśpieszenie Szkolenia*105-min. Przyśpieszenie Badań*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diament*100\n5-min. Przyśpieszenie Szkolenia*10\n5-min. Przyśpieszenie Badań*10\n5-min. Przyśpieszenie Budowania*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diament*150\nIdealny Frag. 5★ Herosa*1\n5-min. Przyśpieszenie Szkolenia*10\n5-min. Przyśpieszenie Badań*10\n5-min. Przyśpieszenie Budowania*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`Zaloguj się na stronie wydarzenia każdego dnia, aby zaliczyć dzienne logowanie. Zaloguj się przez 1/3/5/7 dni, aby odebrać nagrody za logowanie.`,"title":`Nagroda dziennego logowania`},"id-ID":{"signInfo":[{"name":"Speed up Training 5 menit*10\nSpeed up R&D 5 menit*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"Diamond*50Speed up Training 5 menit*10Speed up R&D 5 menit*10","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"Diamond*100\nSpeed up Training 5 menit*10\nSpeed up R&D 5 menit*10\nSpeed up Pembangunan 5 menit*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"Diamond*150\nFragmen Hero Universal 5★*1\nSpeed up Training 5 menit*10\nSpeed up R&D 5 menit*10\nSpeed up Pembangunan 5 menit*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":`Log elke dag in op de event pagina om je aan te melden. Meld je gedurende 1/3/5/7 dag(en) aan om beloningen te claimen.`,"title":`Dagelijks Inlog Beloning`},"ar-SA":{"signInfo":[{"name":"تسريع التدريب 5 دقائق*10\nتسريع الأبحاث 5 دقائق*10","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129851896725736.png"},{"name":"الماس*50\nتسريع التدريب 5 دقائق\nتسريع الأبحاث 5 دقائق","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852993423614.png"},{"name":"الماس*100\nتسريع التدريب 5 دقائق\nتسريع الأبحاث 5 دقائق\nتسريع البناء 5 دقائق","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129852913341463.png"},{"name":"الماس*150\nقطعة بطل متعددة 5★*1\nتسريع التدريب 5 دقائق\nتسريع الأبحاث 5 دقائق\nتسريع البناء 5 دقائق","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733823297326-19.png"}],"subTitle":``,"title":`Hadiah Sign-In Harian`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '签到领奖';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const showTips = inject("showTips", (txt,code) => {})
const showGetSucc = inject("showGetSucc", (type, pic,name) => {})
const listData = inject("listData", {})
const giftInfo = inject("giftInfo", {})

const curPlatform = pagePlatform

const init = () => {
  compData.signInfo.forEach((item) => {
    item.state = 0
  })
}

watch(
  () => listData,
  (value) => {
    if (value && value.signList) {
      let confList = _.cloneDeep(compData.signInfo)
      compData.signInfo = []
      value.signList.forEach((item, index) => {
        if(confList[index]){
          compData.signInfo.push({
            pic: confList[index].pic,
            state: item.send_status,
            day: item.sign_day,
            name:confList[index].name
          })}
      })
      giftInfo.signInAward = compData.signInfo
    }
  },
  { deep: true }
)

init()

const canClickSign = ref(true)
const signDay = async (day, index) => {
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=signInAward`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=signInAward`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=signInAward`,
  }
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      sign_day: +day,
      language:curLang
    }),
  })
  if (res.result == 1) {
    compData.signInfo[index].state = 2;
    let curGiftName = res.data.send_type == 'sendSerial' ? res.data.send_value:compData.signInfo[index].name;
    showGetSucc(res.data.send_type, compData.signInfo[index].pic,curGiftName)
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")),res.code)
  }
  return res.result == 1
}

;
      // 签到item的click事件
      const u_c_MNBL18_event_W81W61= async (e,index)=>{
        try {pageData.seeGift = [compData.signInfo[index]]
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 签到可领按钮的click事件
      const u_c_S2XY22_event_8J5W26= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (!canClickSign.value) return;
canClickSign.value = false;
window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: `领取签到奖励`,
  gameId: pageData.gameId,
  aid: pageData.pageId
});
let curIndex = compData.signInfo.findIndex(item => item.state == 1);
if (~curIndex) {
  await signDay(compData.signInfo[curIndex].day, curIndex);
} else {
  let finishIndex = compData.signInfo.findIndex(item => item.state == 2);
  showTips(
    getLangTxt(
      finishIndex == compData.signInfo.length - 1 ? '-20001' : '-10010',
      getLangTxt('common')
    ),
    ''
  );
}
canClickSign.value = true;} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.default{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16715378751190.png);
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.default{
.u_c_EHIZ29.normal{
position:relative;

}
}.default{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.default{
.u_c_V2CG35.normal{
position:relative;

}
}.default{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.default{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.default{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.default{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.default{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.default{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.default{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.zh-CN{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.zh-CN{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.zh-CN{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-CN{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.zh-CN{
.u_c_EHIZ29.normal{
position:relative;

}
}.zh-CN{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.zh-CN{
.u_c_V2CG35.normal{
position:relative;

}
}.zh-CN{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.zh-CN{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.zh-CN{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.zh-CN{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.zh-CN{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.zh-CN{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.zh-CN{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.zh-TW{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.zh-TW{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.zh-TW{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-TW{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.zh-TW{
.u_c_EHIZ29.normal{
position:relative;

}
}.zh-TW{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.zh-TW{
.u_c_V2CG35.normal{
position:relative;

}
}.zh-TW{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.zh-TW{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.zh-TW{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.zh-TW{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.zh-TW{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.zh-TW{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.zh-TW{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.en-US{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.en-US{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.en-US{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.en-US{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.en-US{
.u_c_EHIZ29.normal{
position:relative;

}
}.en-US{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.en-US{
.u_c_V2CG35.normal{
position:relative;

}
}.en-US{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.en-US{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.en-US{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.en-US{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.en-US{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.en-US{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.en-US{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.ja-JP{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ja-JP{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.ja-JP{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ja-JP{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.ja-JP{
.u_c_EHIZ29.normal{
position:relative;

}
}.ja-JP{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.ja-JP{
.u_c_V2CG35.normal{
position:relative;

}
}.ja-JP{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.ja-JP{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.ja-JP{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.ja-JP{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.ja-JP{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.ja-JP{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.ja-JP{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.ko-KR{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ko-KR{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.ko-KR{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ko-KR{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.ko-KR{
.u_c_EHIZ29.normal{
position:relative;

}
}.ko-KR{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.ko-KR{
.u_c_V2CG35.normal{
position:relative;

}
}.ko-KR{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.ko-KR{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.ko-KR{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.ko-KR{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.ko-KR{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.ko-KR{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.ko-KR{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.th-TH{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.th-TH{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.th-TH{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.th-TH{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.th-TH{
.u_c_EHIZ29.normal{
position:relative;

}
}.th-TH{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.th-TH{
.u_c_V2CG35.normal{
position:relative;

}
}.th-TH{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.th-TH{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.th-TH{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.th-TH{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.th-TH{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.th-TH{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.th-TH{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.vi-VN{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.vi-VN{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.vi-VN{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.vi-VN{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.vi-VN{
.u_c_EHIZ29.normal{
position:relative;

}
}.vi-VN{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.vi-VN{
.u_c_V2CG35.normal{
position:relative;

}
}.vi-VN{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.vi-VN{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.vi-VN{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.vi-VN{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.vi-VN{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.vi-VN{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.vi-VN{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.de-DE{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.de-DE{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.de-DE{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.de-DE{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.de-DE{
.u_c_EHIZ29.normal{
position:relative;

}
}.de-DE{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.de-DE{
.u_c_V2CG35.normal{
position:relative;

}
}.de-DE{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.de-DE{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.de-DE{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.de-DE{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.de-DE{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.de-DE{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.de-DE{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.fr-FR{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.fr-FR{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.fr-FR{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.fr-FR{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.fr-FR{
.u_c_EHIZ29.normal{
position:relative;

}
}.fr-FR{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.fr-FR{
.u_c_V2CG35.normal{
position:relative;

}
}.fr-FR{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.fr-FR{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.fr-FR{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.fr-FR{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.fr-FR{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.fr-FR{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.fr-FR{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.es-ES{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.es-ES{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.es-ES{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.es-ES{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.es-ES{
.u_c_EHIZ29.normal{
position:relative;

}
}.es-ES{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.es-ES{
.u_c_V2CG35.normal{
position:relative;

}
}.es-ES{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.es-ES{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.es-ES{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.es-ES{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.es-ES{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.es-ES{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.es-ES{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.pt-PT{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.pt-PT{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.pt-PT{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.pt-PT{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.pt-PT{
.u_c_EHIZ29.normal{
position:relative;

}
}.pt-PT{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.pt-PT{
.u_c_V2CG35.normal{
position:relative;

}
}.pt-PT{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.pt-PT{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.pt-PT{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.pt-PT{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.pt-PT{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.pt-PT{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.pt-PT{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.it-IT{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.it-IT{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.it-IT{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.it-IT{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.it-IT{
.u_c_EHIZ29.normal{
position:relative;

}
}.it-IT{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.it-IT{
.u_c_V2CG35.normal{
position:relative;

}
}.it-IT{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.it-IT{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.it-IT{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.it-IT{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.it-IT{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.it-IT{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.it-IT{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.tr-TR{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.tr-TR{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.tr-TR{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.tr-TR{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.tr-TR{
.u_c_EHIZ29.normal{
position:relative;

}
}.tr-TR{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.tr-TR{
.u_c_V2CG35.normal{
position:relative;

}
}.tr-TR{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.tr-TR{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.tr-TR{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.tr-TR{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.tr-TR{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.tr-TR{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.tr-TR{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.pl-PL{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.pl-PL{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.pl-PL{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.pl-PL{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.pl-PL{
.u_c_EHIZ29.normal{
position:relative;

}
}.pl-PL{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.pl-PL{
.u_c_V2CG35.normal{
position:relative;

}
}.pl-PL{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.pl-PL{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.pl-PL{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.pl-PL{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.pl-PL{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.pl-PL{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.pl-PL{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.id-ID{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.id-ID{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.id-ID{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.id-ID{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.id-ID{
.u_c_EHIZ29.normal{
position:relative;

}
}.id-ID{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.id-ID{
.u_c_V2CG35.normal{
position:relative;

}
}.id-ID{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.id-ID{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.id-ID{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.id-ID{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.id-ID{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.id-ID{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.id-ID{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}.ar-SA{
.u_c_PU3219.normal{
position:relative;
width:100.00vw;
height:63.39vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732702234317-43.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ar-SA{
.u_c_4XT324.normal{
position:relative;
width:40.26vw;
height:9.69vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:3.85vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_4XT324.normal.text{
width:100%;
height:auto;

}
}.ar-SA{
.u_c_FWNF17.normal{
position:relative;
margin-top:1.67vw;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ar-SA{
.u_c_PHXH28.normal{
position:relative;
text-align:center;
margin-top:1.56vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_PHXH28.normal .txt{
color:#ffffff;
font-size:1.15vw;

}
}.ar-SA{
.u_c_EHIZ29.normal{
position:relative;

}
}.ar-SA{
.u_c_U3DG31.normal{
position:relative;
margin:auto 1.04vw;

}
}.ar-SA{
.u_c_V2CG35.normal{
position:relative;

}
}.ar-SA{
.u_c_IA8J17.normal{
position:relative;
width:61.30vw;
margin:auto;
margin-top:1.15vw;
text-align:center;

}

.u_c_IA8J17.normal .sign-item{
display:inline-block;
margin:auto 0.78vw 1.30vw;

}

.u_c_IA8J17.normal .sign-img{
max-width:90%;

}
}.ar-SA{
.u_c_MNBL18.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144183-20.jpeg);
background-size:contain;
width:10.94vw;
height:11.88vw;

}
}.ar-SA{
.u_c_156W17.normal{
position:relative;
font-size:1.15vw;
color:#eeecec;
text-align:center;
margin:auto;
margin-top:0.94vw;

}
}.ar-SA{
.u_c_W7BU19.normal{
position:relative;
width:9.90vw;
height:6.09vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:1.46vw;

}

.u_c_W7BU19.u_c_W7BU19_0{
width:8.18vw;
height:5.10vw;
margin-top:1.51vw;

}

.u_c_W7BU19.u_c_W7BU19_1{
width:7.86vw;
height:6.56vw;
margin-top:1.20vw;

}

.u_c_W7BU19.u_c_W7BU19_2{
width:8.49vw;
height:4.74vw;
margin-top:1.98vw;

}

.u_c_W7BU19.u_c_W7BU19_3{
width:10.05vw;
height:7.24vw;
margin-top:1.56vw;

}

.u_c_W7BU19.u_c_W7BU19_4{
width:8.59vw;
height:4.17vw;
margin-top:2.29vw;

}

.u_c_W7BU19.u_c_W7BU19_5{
width:9.06vw;
height:4.84vw;
margin-top:1.82vw;

}

.u_c_W7BU19.u_c_W7BU19_6{
width:8.13vw;
height:5.16vw;
margin-top:1.67vw;

}
}.ar-SA{
.u_c_1TRJ20.normal{
position:absolute;
width:4.01vw;
height:4.01vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:5.21vw;
right:4.01vw;

}
}.ar-SA{
.u_c_S2XY22.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:24.58vw;
height:7.34vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.52vw;

}
}.ar-SA{
.u_c_S2S020.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.50vw;
font-weight:bold;

}
}
</style>
